export default __webpack_public_path__ + "static/media/DharmaGothicE_Bold_R.2d0cd4d8.otf";